export enum DocumentType {
  ReleaseNote = 'ReleaseNote',
  Manual = 'Manual',
  GMPPages = 'GMPPages'
}
